// extracted by mini-css-extract-plugin
export default {"body":"Layout_body__Ur8gw","container":"Layout_container__YsDMV","bodyfake":"Layout_bodyfake__89mTl","miniContainer":"Layout_miniContainer__aPMpY"};